// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static-assets/js/" + chunkId + ".js?id=" + {"52":"b2069b7899f64fa0","129":"68a4c9bc68b0b6a0","490":"1f966a87a5757b00"}[chunkId] + "";
};